export default "__VITE_ASSET__B6n3RnBp__"